import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-alert-modal',
    templateUrl: './alert-modal.component.html',
    styleUrls: ['./alert-modal.component.scss'],
    standalone: false
})
export class AlertModalComponent implements OnInit {
  disableClose: boolean = false;
  submitText: string;
  otherText: string;
  body: string;
  title: string;
  isOtherTextDisabled: boolean = true;
  isThridButtonDisabled: boolean = true;
  thirdButtonText: string;
  constructor(public diaglogRef: MatDialogRef<AlertModalComponent>) { }

  ngOnInit() {
  }

  submit() {
    this.diaglogRef.close(this.submitText);
  }

  close() {
    this.diaglogRef.close();
  }
}
